import Cookies from "js-cookie";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Main from "../Components/Main/Main";
import Search from "../Components/Main/Search";
import ReaderView from "../Components/ReadStory/ReaderView";
import Report from "../Components/Report/Report";
import Stories from "../Components/Stories/Stories";
import StoryDetails from "../Components/Story/StoryDetails";
import Write from "../Components/Write/Write";
import Upload from "../Components/Upload/Upload";
import WriterFeedback from "../Components/WriterFeedback/WriterFeedback";
import { getInfo } from "../utils/hooks";

const WriterLayout: React.FC = () => {
    const userInfo = getInfo();

    if (userInfo === null) {
        return <Redirect to="/login" />;
    } else if (Cookies.get('admin')) {
        return <Redirect to="/admin" />;
    } else if (userInfo.intent === "critic") {
        return <Redirect to="/critic" />;
    } else if (userInfo.intent === "producer") {
        return <Redirect to="/producer" />;
    }

    return (
        <Switch>
            <Route path="/writer/story/my" component={Stories} />
            <Route path="/writer/story/:id" component={StoryDetails} />
            <Route path="/writer/search" component={Search} />
            <Route path="/writer/write" component={Write} />
            <Route path="/writer/read/:id" component={ReaderView} />
            <Route path="/writer/report/:id" component={Report} />
            <Route path="/writer/upload" component={Upload} />
            <Route path="/writer/feedback/:id" component={WriterFeedback} />
            <Route exact path="" component={Main} />
        </Switch>
    );
};

export default WriterLayout;
